import { createStore } from 'vuex'
import alerts from './modules/alerts'
import auth from './modules/auth'
import misDatos from './modules/misDatos'
import portalConfig from './modules/portalConfig'
import taxonomy from './modules/taxonomy'
import grupoFamiliar from './modules/grupoFamiliar'
import portalHome from './modules/portalHome'
import asistenteTurnos from './modules/asistenteTurnos'
import guestSession from './modules/guestSession'

export default createStore({
  state: () => ({}),
  mutations: {},
  actions: {},
  modules: {
    alerts,
    auth,
    misDatos,
    portalConfig,
    taxonomy,
    grupoFamiliar,
    portalHome,
    asistenteTurnos,
    guestSession,
  },
})
